import { Jumbo } from "./components/Jumbo";
import { HelpSection } from "./components/Help";
import { AssessmentsSection } from "./components/Assessments";
import { HappyClientsSection } from "./components/HappyClients";
import { Testimonials } from "./components/Testimonials";
import { WorkWithUs } from "./components/WorkWithUs";
import { Footer } from "./components/Footer";
import { TalkToUsNow } from "./components/TalkToUsNow";

// Mock data
import { testimonials, help, social, navigation } from "./mock";

function App() {
  return (
    <>
      <Jumbo links={navigation} socialLinks={social} />
      <HelpSection items={help} />
      <AssessmentsSection amount={80295} />
      <HappyClientsSection />
      <Testimonials testimonials={testimonials} />
      <HelpSection items={help} />
      <TalkToUsNow />
      <div style={{ margin: "0em auto" }}>
        <WorkWithUs />
      </div>
      <Footer socialLinks={social} links={navigation} />
    </>
  );
}

export default App;
